
import { defineComponent } from "vue";
import NewStationList from "@/components/processTracking/NewStationsList.vue";

export default defineComponent({
  components: { NewStationList },
  data() {
    return {};
  },
  methods: {},
});
